module.exports = __webpack_public_path__ + "img/align_center_hotizontally.779b2471.svg";